module.exports = __webpack_public_path__ + "public/logo-thick.png";